/**
 * Updates the meta tags for social media previews
 * @param {Object} options - The meta tag data
 */

export const updateMetaTags = (options = {}) => {
  try {
    const {
      title = 'Distorise Music',
      description = 'Discover and enjoy unique music tracks on Distorise Music',
      imageUrl, // Don't set default here
      pageUrl = window.location.href,
      type = 'website'
    } = options;

    // IMPORTANT: Use fully qualified URL for backend
    // This is the key fix for cross-domain issues
    const apiBaseUrl = process.env.REACT_APP_API_URL;
    
    // Ensure imageUrl is absolute and properly formatted
    let finalImageUrl = imageUrl;
    if (!finalImageUrl) {
      finalImageUrl = `${apiBaseUrl}/default-preview.jpg`;
    } else if (!finalImageUrl.startsWith('http')) {
      // If URL is relative, make it absolute
      finalImageUrl = `${apiBaseUrl}${finalImageUrl.startsWith('/') ? '' : '/'}${finalImageUrl}`;
    }

    // Image considerations for Telegram
    if (navigator.userAgent.toLowerCase().includes('telegram')) {
      // Telegram prefers JPG format with specific dimensions
      if (!finalImageUrl.endsWith('.jpg') && !finalImageUrl.includes('.jpg?')) {
        finalImageUrl = finalImageUrl.replace(/\.(png|gif|webp)($|\?)/, '.jpg$2');
      }
    }
    
    // Ensure .jpg extension is present
    if (!finalImageUrl.endsWith('.jpg') && !finalImageUrl.includes('.jpg?')) {
      finalImageUrl = `${finalImageUrl}.jpg`;
    }
    
    // Add cache busting parameter
    if (!finalImageUrl.includes('?v=')) {
      finalImageUrl = `${finalImageUrl}${finalImageUrl.includes('?') ? '&' : '?'}v=${Date.now()}`;
    }
    
    // console.log(`Setting meta tags with absolute image URL: ${finalImageUrl}`);

    // Set meta tags
    document.title = title;
    
    const setMetaTag = (attr, value, content) => {
      let meta = document.querySelector(`meta[${attr}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, value);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    
    // Set all meta tags with absolute URLs
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:image', finalImageUrl);
    setMetaTag('property', 'og:url', pageUrl);
    setMetaTag('property', 'og:type', type);
    setMetaTag('property', 'og:image:width', '1200');
    setMetaTag('property', 'og:image:height', '630');
    
    // Twitter/X Card tags - keep for compatibility
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
    setMetaTag('name', 'twitter:image', finalImageUrl);
    
    // Telegram specific meta tags
    setMetaTag('property', 'telegram:title', title);
    setMetaTag('property', 'telegram:description', description);
    setMetaTag('property', 'telegram:image', finalImageUrl);
    
    // console.log('Meta tags updated successfully:', {
    //   title,
    //   description,
    //   imageUrl: finalImageUrl,
    //   pageUrl,
    //   type
    // });
  } catch (error) {
    console.error('Error updating meta tags:', error);
  }
};